// extracted by mini-css-extract-plugin
export var navbarSubLink = "z_gb d_gb d_f4 d_0 d_cc d_dm d_bs d_bT";
export var menuLink = "z_tl d_f0 d_dB";
export var subPageLink = "z_gf d_gf";
export var burger = "z_vy";
export var sublinkSize = "z_vz";
export var linkSize = "z_vB";
export var Link = "z_rl q_rl q_qC q_qX";